import React from "react";
import { useTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import { useHistory } from "react-router-dom";
import { Box, Grid2 } from "@mui/material";
import {
  MyFulfilledLeaves,
  MyLeaveDetailsChart,
  MyLeaveLeaveCards,
  MyLeaveYearHeader,
} from "my-leave/components";
import { OcCard, OcPageTransition } from "oc/components";
import { useOcCurrentUserState, useOcIsMobile } from "oc/hooks";

export const MyLeaveMyYearlyLeavesPage = () => {
  const { t } = useTranslation();
  let { year } = useParams<{ year: string }>();
  const history = useHistory();
  const isMobile = useOcIsMobile();

  const handleIconClick = () => {
    history.goBack();
  };

  const { contractCode: contract } = useOcCurrentUserState();

  return (
    <OcPageTransition>
      <Box>
        <MyLeaveYearHeader handleIconClick={handleIconClick}>
          {year}
        </MyLeaveYearHeader>
        <Grid2
          container
          spacing={0}
          style={{
            flexDirection: isMobile ? "column" : "unset",
            flexWrap: isMobile ? "wrap" : "nowrap",
            padding: isMobile ? "16px 0px" : 8,
            paddingBottom: 0,
          }}
        >
          <Grid2
            size={{ xs: 12, sm: 12, md: 12, lg: 5 }}
            style={{ padding: isMobile ? 0 : 8 }}
          >
            <OcCard label={t("MY_LEAVE_LEAVE_SUMMARY")}>
              <MyLeaveLeaveCards
                selectedYear={Number(year)}
                contractCode={contract}
              />
            </OcCard>
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 12, md: 12, lg: 5 }}
            style={{ padding: isMobile ? "16px 0px 0px 0px" : 8 }}
          >
            <Box id="leave-details-chart">
              <OcCard label={t("MY_LEAVE_LEAVE_DETAILS")}>
                <MyLeaveDetailsChart selectedYear={Number(year)} />
              </OcCard>
            </Box>
          </Grid2>
        </Grid2>
        {isMobile && <Box height="16px" />}
        <Grid2
          container
          spacing={0}
          style={{
            flexDirection: isMobile ? "column" : "row",
            flexWrap: isMobile ? "nowrap" : "wrap",
            padding: isMobile ? "0px 0px 16px 0px" : 8,
          }}
        >
          <Grid2
            size={{ xs: 12, sm: 12, md: 12, lg: 12 }}
            style={{ padding: isMobile ? 0 : 8 }}
          >
            <OcCard label={t("MY_LEAVE_MY_FULFILLED_LEAVES_AND_ABSENCES")}>
              <MyFulfilledLeaves
                selectedYear={Number(year)}
                isMobile={isMobile}
              />
            </OcCard>
          </Grid2>
        </Grid2>
      </Box>
    </OcPageTransition>
  );
};

export default MyLeaveMyYearlyLeavesPage;
